/**
 * Multiplier to convert satoshi to 1e18 precision.
 */
const SATOSHI_MULTIPLIER = 10n ** 10n;
export function toSatoshi(amount) {
    const remainder = amount % SATOSHI_MULTIPLIER;
    const satoshis = (amount - remainder) / SATOSHI_MULTIPLIER;
    return satoshis;
}
export function fromSatoshi(amount) {
    return amount * SATOSHI_MULTIPLIER;
}
//# sourceMappingURL=satoshi-converter.js.map